<template>
  <section class="global-box">
    <div class="content-box">
      <h2>Quem somos</h2>
      <p>
        Nós da Click Gestão temos o objetivo de promover a inclusão digital
        e fornecer aplicações que facilitem o dia a dia na gestão de seu negócio,
        de maneira rápida, fácil e eficiente.<br>
        Nossas soluções são desenvolvidas utilizando tecnologia de ponta, de
        maneira a deixar a solução apresentada o mais eficiente e performática.
      </p>
      <h3>Intermediador de negócios</h3>
      <section class="intermediation">
        <p>A Diatech Representação & Consultoria é nossa parceira exclusivo na
          intermediação de negócios de nossas soluções personalizadas.
        </p>
        <a href="https://diatech.com.br" target="_blank">
          <img src="https://thiagoalmeida.com.br/img/clients/brandDiatech.svg" >
        </a>
      </section>
      <a href="https://diatech.com.br" target="_blank" class="button">
        Saiba mais
      </a>
    </div>
  </section>
</template>

<script>
export default {
  name: 'about-session',
  props: {
    complete: {
      type: Boolean,
      default: true,
    },
    isFlutuation: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      flutuation: false,
    };
  },
  methods: {

  },
};
</script>

<style lang="sass" scoped>
  @import "../assets/sass/main.sass"
  section
    width: 100%
  .global-box
    padding: 0 !important
    overflow: initial !important
    .content-box
      h3
        text-align: left
        margin-top: 32px
      .intermediation
        display: flex
        p
          width: 70%
          padding-right: 32px
        a
          margin: auto
          img
            width: 230px
    @media (max-width: $widthTerciarySmall)
      p
        text-align: justify
      .content-box
        h3
          text-align: center
        .intermediation
          flex-wrap: wrap
          p
            width: 100%
            padding-right: 0
            padding-bottom: 32px
          a
            padding-bottom: 32px
</style>
